/**
 * The funnel: what visitors actually do with the instrument.
 *
 * GA4 is configured in index.html and stays inert while its Measurement ID is a
 * placeholder, so every call here is a no-op until the property exists. The
 * page_view comes from the tag itself; these are the actions that matter.
 */

type Params = Record<string, string | number | boolean>;

declare global {
  interface Window {
    gtag?: (command: string, target: string | Date, params?: Params) => void;
    obrainGa?: { active: boolean; id: string };
  }
}

export function track(event: string, params: Params = {}): void {
  if (window.obrainGa?.active !== true) return;

  window.gtag?.("event", event, params);
}
